<template>
	<div class="header-bar is-fixed">
		<div class="header-left">
			<span class="iconfont icon-arrowleft" v-on:click="goBack" v-if="showBack"></span>
		</div>
		<div class="header-title">
      <slot></slot>
    </div>
		<div class="header-right">
			<slot name="right"></slot>
		</div> 
	</div>
</template>

<script>
export default {
  name: 'HeaderBar',
  props: {
    showBack: {
      type: Boolean,
      default: true
    },
    align: {
      type: String,
      default: 'center'
    },
    customBack: {
      type: Function
    }
  },
  data () {
    return {
    }
  },
  methods: {
    goBack () {
      if (this.customBack) {
        this.customBack()
      } else {
        window.history.go(-1)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
